import './../app/shared/operators';

import { of } from 'rxjs/observable/of';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as usersActions from '../actions/users.actions';

import { Api } from '../providers/api/api';
import { Storage } from '@ionic/storage';

@Injectable()
export class UsersEffects {
  constructor(
    private actions$: Actions,
    private api: Api,
    private storage: Storage
  ) {
  }

  @Effect()
  fetchUsers$: Observable<Action> = this.actions$
  .ofType(usersActions.FETCH_USERS)
  .switchMap(() => this.api.fetchUsers())
  .map(users => {
    return new usersActions.FetchUsersSuccess(users);
  }).catch((err) => of(new usersActions.FetchUsersFailure(err)));

  @Effect()
  addUser$: Observable<Action> = this.actions$
  .ofType(usersActions.ADD_USER)
  .map((action: usersActions.AddUser) => {
    return action.payload;
  })
  .switchMap((payload) => this.api.addUser(payload))
  .map(user => {
    return new usersActions.AddUserSuccess(user);
  }).catch((err) => of(new usersActions.AddUserFailure(err)));

  @Effect()
  deleteUser$: Observable<Action> = this.actions$
  .ofType(usersActions.DELETE_USER)
  .map((action: usersActions.DeleteUser) => {
    return action.payload;
  })
  .switchMap((payload) => this.api.deleteUser(payload))
  .map(user => {
    return new usersActions.DeleteUserSuccess(user);
  }).catch((err) => of(new usersActions.DeleteUserFailure(err)));

}




// WEBPACK FOOTER //
// ./src/effects/users.effects.ts